function findDisplayableBenchmarks(benchmarkArray) {
  let displayableBenchmarks = []
  let gotFirstBenchmark = true

  benchmarkArray.map((benchObject) => {
    if (benchObject.benchmark === 'no') {
      displayableBenchmarks.push(benchObject)
    } else if (benchObject.benchmark === 'yes' && gotFirstBenchmark) {
      displayableBenchmarks.push(benchObject)
      gotFirstBenchmark = false
    }
  })

  return displayableBenchmarks
}

function getFixedDecimal(val) {
  return isNaN(Number(val)) ? '--' : Number(val).toFixed(2)
}

export { findDisplayableBenchmarks, getFixedDecimal }
